const configuredActionsPerStep = Number(process.env.REACT_APP_MAX_ACTIONS_PER_STEP || 10);
const actionsPerStep = Number.isInteger(configuredActionsPerStep) && configuredActionsPerStep > 0
  ? configuredActionsPerStep
  : 10;

export const GUEST_JOURNEY_LIMITS = Object.freeze({
  discoveryResponsesPerAttempt: 10,
  goals: 1,
  stepsPerGoal: 7,
  actionsPerStep: 7,
});

export const SIGNED_IN_JOURNEY_LIMITS = Object.freeze({
  recommendedGoals: 3,
  goals: 5,
  stepsPerGoal: 20,
  actionsPerStep,
  targetActionsPerStep: Object.freeze({ minimum: 3, maximum: 5 }),
});
